import { LayoutDashboard, FileText, FolderOpen, Users, Settings, Building2 } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { routes } from "@/lib/routes";

export interface OrgNavItem {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
  group: "primary" | "secondary";
  /** ST6: only render for the org `owner` role (e.g. the Eigentümer-Bereich). */
  ownerOnly?: boolean;
}

/**
 * Single source of truth for org navigation items.
 * Used by OrgSidebar, OrgDropdown, and OrgMobileMenu.
 */
export const ORG_NAV_ITEMS: OrgNavItem[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: routes.organization.dashboard,
    icon: LayoutDashboard,
    group: "primary",
  },
  {
    id: "anfragen",
    label: "Anfragen",
    href: routes.organization.requests.list,
    icon: FileText,
    group: "primary",
  },
  {
    id: "projekte",
    label: "Projekte",
    href: routes.organization.projects.list,
    icon: FolderOpen,
    group: "primary",
  },
  {
    id: "benutzer",
    label: "Benutzer",
    href: routes.organization.users,
    icon: Users,
    group: "secondary",
  },
  {
    id: "eigentuemer-bereich",
    label: "Eigentümer-Bereich",
    href: routes.organization.eigentuemerBereich,
    icon: Building2,
    group: "secondary",
    ownerOnly: true,
  },
  {
    id: "einstellungen",
    label: "Einstellungen",
    href: routes.organization.settings,
    icon: Settings,
    group: "secondary",
  },
];

export const ORG_NAV_PRIMARY = ORG_NAV_ITEMS.filter((i) => i.group === "primary");
export const ORG_NAV_SECONDARY = ORG_NAV_ITEMS.filter((i) => i.group === "secondary");
